import { buildProps } from '@xzx-design/utils'

import type { ExtractPropTypes } from 'vue-demi' // test vue-demi
import type Icon from './icon.vue'

export const iconProps = buildProps({
  name: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: '',
  },
  size: {
    type: [Number, String],
    default: undefined,
  },
  iconId: {
    type: String,
    default: '',
  },
})

export type IconProps = ExtractPropTypes<typeof iconProps>
export type IconInstance = InstanceType<typeof Icon>
